module.exports = __webpack_public_path__ + "img/MS_WeaponSword001.4c8099e6.png";